import { render, staticRenderFns } from "./mainNav.vue?vue&type=template&id=57a407a3&scoped=true&"
import script from "./mainNav.vue?vue&type=script&lang=js&"
export * from "./mainNav.vue?vue&type=script&lang=js&"
import style0 from "./mainNav.vue?vue&type=style&index=0&id=57a407a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a407a3",
  null
  
)

export default component.exports